import { CompanyPage, ConsentPage, ContactsPage, CookiesPage, HomePage, NotFoundPage, PricesPage, PrivacyPage, ProjectsPage, ServicesPage } from './Pages';
import { resolveRoute } from './routes';

export function SiteApp({ path }: { path: string }) {
  const route = resolveRoute(path);
  switch (route.page) {
    case 'home': return <HomePage />;
    case 'services': return <ServicesPage />;
    case 'prices': return <PricesPage />;
    case 'projects': return <ProjectsPage />;
    case 'company': return <CompanyPage />;
    case 'contacts': return <ContactsPage />;
    case 'privacy': return <PrivacyPage />;
    case 'consent': return <ConsentPage />;
    case 'cookies': return <CookiesPage />;
    default: return <NotFoundPage path={path} />;
  }
}
